import { FC } from 'react';

import 'shared/common/assets/colors.css';

import { withCommonProviders } from '../../../common/containers/CommonContextProviders';
import { IApplicationCommonRootComponentProps } from '../../../common/types/applicationRootComponent';
import { FormContainer } from '../FormContainers';
import { ListingContainer } from '../ListingContainer';
import { ModalContainer } from '../ModalContainer';
import { LoginWidgetMicrofrontend } from '../../microfrontends/LoginWidgetMicrofrontend';
import { useSelector } from 'react-redux';
import { selectIsOpenAuthorizationModal } from '../../selectors/modal';
import { useGetOffers } from '../../hooks/useGetOffers';

import * as styles from './styles.css';
import { ETestIds } from '../../constants';

export const MortgageMiniCalculatorApp: FC<IApplicationCommonRootComponentProps> = withCommonProviders(() => {
  const isAuthorizedModalOpen = useSelector(selectIsOpenAuthorizationModal);
  const { fetchOffers, ...listingProps } = useGetOffers();

  return (
    <div className={styles['root']} data-testid={ETestIds.CalculatorLayout}>
      <FormContainer fetchOffers={fetchOffers} />
      <ListingContainer {...listingProps} />
      <ModalContainer />
      {isAuthorizedModalOpen && <LoginWidgetMicrofrontend />}
    </div>
  );
});
